import React from 'react';
import { ThemeProvider } from '@mui/material';

import { useAppDispatch } from 'src/redux-file/hooks';
import { setPublicPlatformPortal } from 'src/redux-file/platform/slice';
import { getPlatformPortalAPI } from 'src/utils/api';
import { useAppTheme, useEffectivePlatformPortal } from './hooks';
import { getPortalThemeTokens } from './theme';

interface PlatformPortalProviderProps {
  children: React.ReactNode;
}

function usePortalBodyStyles() {
  const portal = useEffectivePlatformPortal();

  React.useEffect(() => {
    const tokens = getPortalThemeTokens(portal);
    const previousFontFamily = document.body.style.fontFamily;
    const previousBackgroundColor = document.body.style.backgroundColor;

    document.body.style.fontFamily = `${tokens.fontFamily}, sans-serif`;
    document.body.style.backgroundColor = tokens.colors.background;

    return () => {
      document.body.style.fontFamily = previousFontFamily;
      document.body.style.backgroundColor = previousBackgroundColor;
    };
  }, [portal]);
}

export default function PlatformPortalProvider({
  children,
}: PlatformPortalProviderProps) {
  const dispatch = useAppDispatch();
  const theme = useAppTheme();

  usePortalBodyStyles();

  React.useEffect(() => {
    let isActive = true;

    getPlatformPortalAPI()
      .then((portal) => {
        if (isActive) dispatch(setPublicPlatformPortal(portal));
      })
      .catch(() => {
        if (isActive) dispatch(setPublicPlatformPortal(null));
      });

    return () => {
      isActive = false;
    };
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}
